import React from "react";
import styled from "styled-components";
import device from "../helpers/device";
import arrow from "../img/arrow.png";
import Session from "./Session";
import { timeImg } from "../assetManager";

export default class ScheduleRow extends React.Component {
  state = {
    show: false
  };

  renderDefault() {
    return (
      <Schedule className="open last">
        <div className="inner">
          <div className="head">
            <img src={timeImg["time_8"]} width="125" alt="" />
          </div>
          <div className="body">
            <Session />
          </div>
        </div>
      </Schedule>
    );
  }

  handleToggle = () => {
    this.setState(prevState => {
      return { ...this.state, show: !prevState.show };
    });
  };

  render() {
    const { store, data, hallId, scheduleId, ...rest } = this.props;
    if (!store) {
      return this.renderDefault();
    }
    const { entities } = store;
    const openCls = this.state.show ? "open" : "";

    return (
      <Schedule {...rest} className={openCls}>
        <div className="inner">
          <div className="head" onClick={this.handleToggle}>
            <img src={timeImg[`time_${data.id}`]} width="125" alt="" />
            <span>
              <img src={arrow} alt="" width="10" />
            </span>
          </div>
          <div className="body">
            {data.halls.map(({ hall, session }) => (
              <Session
                key={hall}
                hall={hall}
                session={entities.sessions[session]}
                store={store}
                scheduleId={scheduleId}
              />
            ))}
          </div>
        </div>
      </Schedule>
    );
  }
}

const Schedule = styled.div`
  border-top: 1px solid #d9d4d2;
  width: 100%;
  @media ${device.mobileL} {
    margin-top: 20px;
  }
  > .inner {
    padding: 0px 20px 0 20px;
    display: flex;
    flex-direction: column;
    @media ${device.mobileL} {
      flex-direction: row;
      padding: 60px 80px 0 60px;
    }
  }
  &.open {
    .head {
      span {
        transform: rotate(0deg);
      }
    }
    .body {
      display: block;
      @media ${device.mobileL} {
        display: grid;
      }
    }
  }
  .head {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      transform: rotate(-180deg);
    }
    img {
      vertical-align: middle;
      @media ${device.mobileL} {
        width: 160px;
      }
    }
    @media ${device.mobileL} {
      padding: 0 30px 0 0;
      align-items: start;
      span {
        display: none;
      }
    }
  }
  .body {
    width: 100%;
    display: none;
    @media ${device.mobileL} {
      display: grid;
      grid-template-columns: 0.33fr 0.33fr 0.33fr;
    }
  }
`;
